import { render, staticRenderFns } from "./CreateQuotation.vue?vue&type=template&id=65be6929"
import script from "./CreateQuotation.vue?vue&type=script&lang=js"
export * from "./CreateQuotation.vue?vue&type=script&lang=js"
import style0 from "./CreateQuotation.vue?vue&type=style&index=0&id=65be6929&prod&lang=css"
import style1 from "./CreateQuotation.vue?vue&type=style&index=1&id=65be6929&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports